var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllBots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8333 27.3333V14.8333H27.3333V27.3333H14.8333ZM14.8333 13.1666V0.666626H27.3333V13.1666H14.8333ZM0.666666 13.1666V0.666626H13.1667V13.1666H0.666666ZM0.666666 27.3333V14.8333H13.1667V27.3333H0.666666Z",
    fill: "#002266"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllBots);
export default __webpack_public_path__ + "static/media/AllBots.2e01d333d695072061bcd9f4093108b2.svg";
export { ForwardRef as ReactComponent };